export const cursorTypeMap = {
  default: '기본',
  custom: '커스텀 이미지',
  // circle: '원',
};

export const clickEffectTypeMap = {
  particle: '파티클형',
  star: '별이펙트형',
  ripple: '파동형1',
  ripple2: '파동형2',
};

export const shapeMap = {
  dashCircle: 9676,
  heart: 9829,
  diamond: 9830,
  music: 9835,
  plus: 43,
  flower: 42,
  bubble: 176,
};

export const directionMap = {
  goUp: -1,
  goDown: 1,
};
export const directionValueMap = {
  goUp: 'goUp',
  goDown: 'goDown',
};

export interface ImouseSet {
  cursor: {
    type: keyof typeof cursorTypeMap;
    defaultImgURL: '';
    hoverImgURL: '';
    color: string;
  };
  mouseEffect: ImouseEffectSet;
  clickEffect: IclickEffectSet;
}

export interface ImouseEffectSet {
  isActive: boolean;
  shape: keyof typeof shapeMap;
  direction: keyof typeof directionMap;
  color: string;
  color2?: string;
  minSize: number;
  number: number;
}

export interface IclickEffectSet {
  isActive: boolean;
  type: keyof typeof clickEffectTypeMap;
  color: string;
  color2?: string;
  size: number;
  duration: number;
}
